"use strict";
/* globals module */
/**
 * @module calendarEventRoute
 * @description BaasicCalendarEventRoute Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use BaasicCalendarEventRoute Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var common_1 = require("../../../common");
;
var contracts_1 = require("../../../core/contracts");
var CalendarEventRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CalendarEventRoute, _super);
    function CalendarEventRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.findRoute = 'calendar-events/{?searchQuery,page,rpp,sort,embed,fields,ids,ownerIds,calendarIds,calendarNames,statusIds,typeIds,from,to}';
        _this.getRoute = 'calendar-events/{id}/{?embed,fields}';
        _this.getByEmailOrFullNameRoute = 'calendar-events/{id}/{emailOrFullName}';
        _this.createRoute = 'calendar-events';
        _this.updateRoute = 'calendar-events/{id}';
        _this.deleteRoute = 'calendar-events/{id}';
        _this.purgeRoute = 'calendar-events/{id}/purge';
        return _this;
    }
    /**
     * Parses find route which can be expanded with additional GetCalendarEventOptions. Supported items are:
     * - `searchQuery` - A string referencing CalendarEvent properties using the phrase or BQL (Baasic Query Language) search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain CalendarEvent subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the CalendarEvent property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * - `ids` - CalendarEvent ids which uniquely identify CalendarEvent resources that need to be retrieved.
     * - `ownerIds` - Owner ids which uniquely identify event owners used for filtering.
     * - `calendarIds` - Calendar ids which uniquely identify Calendar resources used for filtering.
     * - `calendarNames` - Calendar names which identify Calendar resources used for filtering.
     * - `statusIds` - CalendarEventStatus ids which uniquely idendify CalendarEventStatuses used for filtering.
     * - `typeIds` - CalendarEventType ids which uniquely identify CalendarEventTypes used for filtering.
     * - `from` - Fluent syntax for 'From' date. Used to limit the dataset to only use resources starting from this date
     * - `to` - Fluent syntax for 'To' date. Used to limit the dataset to only use resources ending to this date.
     * @method
     * @param options Query resource GetCalendarEventOptions object.
     * @example calendarEventRoute.find({searchQuery: '<search-phrase>'});
     */
    CalendarEventRoute.prototype.find = function (options) {
        var opt;
        if (options) {
            opt = options;
            opt.to = this.getToDate(opt);
            opt.from = this.getFromDate(opt);
        }
        else {
            opt = {};
        }
        return _super.prototype.baseFind.call(this, this.findRoute, opt);
    };
    /**
     * Parses get route which must be expanded with the identifier of the previously created CalendarEvent resource. This route can be expanded using additional GetRequestOptions. Supported items are:
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param id CalendarEvent id which uniquely identifies CalendarEvent resource that needs to be retrieved.
     * @param options Query resource options object.
     * @example calendarEventRoute.get(id);
     */
    CalendarEventRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses getByEmailOrFullName route which must be expanded with the identifier of the previously created CalendarEvent resource
     * The route must also be expanded with the identifier of the previously created CalendarResource and the email/FullName.
     * @param id CalendarEvent identifier which uniquely identifies previously created CalendarEvent resource.
     * @param emailOrFullName Email or full name.
     * @param options Query resource options object.
     * @example calendarEventRoute.get(id, email@example.com, options);
     */
    CalendarEventRoute.prototype.getByEmailOrFullName = function (id, emailOrFullName, options) {
        var params = this.modelMapper.getParams(options);
        params.emailOrFullName = emailOrFullName;
        return _super.prototype.baseGet.call(this, this.getByEmailOrFullNameRoute, id, params);
    };
    /**
     * Parses create route. This URI template does not expose any additional options.
     * @method
     * @param data A CalendarEvent object that needs to be inserted into the system.
     * @example calendarEventRoute.create(data);
     */
    CalendarEventRoute.prototype.create = function (data) {
        return _super.prototype.baseCreate.call(this, this.createRoute, data);
    };
    /**
     * Parses update route. This URI template does not expose any additional options.
     * @method
     * @param data A CalendarEvent object used to update specified CalendarEvent resource.
     * @example calendarEventRoute.update(data);
     */
    CalendarEventRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
     * Parses delte route. This URI template does not expose any additional options.
     * @method
     * @param data A CalendarEvent object that will be deleted from the system.
     * @example calendarEventRoute.delete(data);
     */
    CalendarEventRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    /**
     * Parses purge route. This URI template does not expose any additional options.
     * @method
     * @param calendarId CalendarId identifier that uniquely identifies a calendar resource that will have all of it's events purged.
     * @example calendarEventRoute.purge(calendar);
     */
    CalendarEventRoute.prototype.purge = function (calendarId) {
        return _super.prototype.baseDelete.call(this, this.purgeRoute, calendarId);
    };
    CalendarEventRoute.prototype.getToDate = function (options) {
        if (!this.utility.isUndefined(options.to) && options.to !== null) {
            return options.to.toISOString();
        }
        return undefined;
    };
    CalendarEventRoute.prototype.getFromDate = function (options) {
        if (!this.utility.isUndefined(options.from) && options.from !== null) {
            return options.from.toISOString();
        }
        return undefined;
    };
    var _a;
    CalendarEventRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], CalendarEventRoute);
    return CalendarEventRoute;
}(common_1.BaseRoute));
exports.CalendarEventRoute = CalendarEventRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 
